import admins from './admins/admins'
import main from './main/main'
import auth from './auth/auth'
export default {
  admins,
  main,
  auth
}
